export const homePageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": ["Restaurant", "Organization"],
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      legalName: "Nonvee Foods Private Limited",
      url: "https://barbequeen.com/",
      logo: {
        "@type": "ImageObject",
        url: "https://barbequeen.com/images/logo.png",
      },
      image: "https://barbequeen.com/images/home-banner.jpg",
      telephone: "+919597228788",
      foundingDate: "1999",
      slogan: "Where authentic royal flavours meet timeless culinary heritage.",
      description:
        "Crafting premium Indian, Chinese, Tandoori & BBQ specialties since 1999. Barbequeen Restaurant offers dine-in, takeaway, delivery, party halls, and outdoor catering.",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Indian",
        "Chinese",
        "Tandoori",
        "Biryani",
      ],
      hasMenu: { "@id": "https://barbequeen.com/menu#menu" },
      address: {
        "@type": "PostalAddress",
        streetAddress: "# 32/32-1, Valmiki Street",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636005",
        addressCountry: "IN",
      },
      openingHoursSpecification: [
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ],
          opens: "11:00",
          closes: "23:00",
        },
      ],
      employee: [
        {
          "@type": "Person",
          name: "Mohamed Umar",
          jobTitle: "General Manager",
        },
        {
          "@type": "Person",
          name: "Amir Khan",
          jobTitle: "Chef",
        },
        {
          "@type": "Person",
          name: "SK Jumuna",
          jobTitle: "Chef",
        },
      ],
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: 5.0,
        reviewCount: 2,
        bestRating: 5,
        worstRating: 1,
      },
      review: [
        {
          "@type": "Review",
          author: {
            "@type": "Person",
            name: "Denver",
          },
          reviewBody:
            "Nice place. Food was great and was served with love. Wide selection of food. An interesting thing was the histories of some special dishes displayed on the walls.",
          reviewRating: {
            "@type": "Rating",
            ratingValue: 5,
            bestRating: 5,
            worstRating: 1,
          },
        },
        {
          "@type": "Review",
          author: {
            "@type": "Person",
            name: "Aadhi",
          },
          reviewBody:
            "The way the food is presented is subtle and the taste is beyond top notch. If you are expecting a good feast this place is the place to go and kudos to the staff for their hospitality!.",
          reviewRating: {
            "@type": "Rating",
            ratingValue: 5,
            bestRating: 5,
            worstRating: 1,
          },
        },
      ],
    },
    {
      "@type": "WebPage",
      "@id": "https://barbequeen.com/#webpage",
      url: "https://barbequeen.com/",
      name: "Barbequeen Restaurant | Authentic BBQ & Biryani",
      description:
        "Experience authentic royal flavours, double marinated grill chicken, wood-fire dum biryani, and tandoori delicacies at Barbequeen Restaurant.",
      inLanguage: "en-IN",
      publisher: { "@id": "https://barbequeen.com/#organization" },
      about: { "@id": "https://barbequeen.com/#organization" },
    },
    {
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Which is the best restaurant in Salem?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen is one of the best restaurants in Salem, serving authentic wood-fire dum biryani, BBQ grills, tandoori, and family meals. Established in 1999, we offer dine-in, takeaway, delivery, and outdoor catering across Salem.",
          },
        },
        {
          "@type": "Question",
          name: "Which restaurant serves the best biryani in Salem?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen is a popular choice for the best biryani in Salem. Our Chicken, Mutton, and Mandi Biryani are prepared using premium Seeraga Samba rice, traditional dum cooking, and authentic South Indian spices.",
          },
        },
        {
          "@type": "Question",
          name: "Which is the best restaurant in Coimbatore?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen is one of the best restaurants in Coimbatore, located in Saibaba Colony. We serve authentic biryani, BBQ grills, shawarma, mandi, tandoori, and multi-cuisine dishes in a family-friendly atmosphere.",
          },
        },
        {
          "@type": "Question",
          name: "Where can I get the best biryani in Coimbatore?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Looking for the best biryani in Coimbatore? Barbequeen serves freshly prepared Chicken, Mutton, and Bucket Biryani using traditional recipes, premium ingredients, and authentic dum cooking techniques.",
          },
        },
        {
          "@type": "Question",
          name: "Which is the best restaurant in Erode?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen is one of the best restaurants in Erode, offering authentic biryani, charcoal BBQ, tandoori, Chinese cuisine, and family dining. Visit our branch on Perundurai Road for dine-in, takeaway, or delivery.",
          },
        },
        {
          "@type": "Question",
          name: "Where can I find the best biryani in Erode?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen is known for serving some of the best biryani in Erode. Enjoy freshly prepared Chicken, Mutton, Family Bucket Biryani, and Mandi made with traditional recipes and premium ingredients.",
          },
        },
        {
          "@type": "Question",
          name: "Which restaurant is best for family dining?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen is a preferred family restaurant with spacious seating, quality food, and a diverse menu including biryani, BBQ, mandi, Chinese, seafood, and vegetarian dishes for all age groups.",
          },
        },
        {
          "@type": "Question",
          name: "Which restaurant is best for birthday celebrations?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen is an excellent venue for birthday parties, family gatherings, and corporate events. We offer spacious seating, customized menus, delicious BBQ, authentic biryani, and memorable dining experiences.",
          },
        },
        {
          "@type": "Question",
          name: "Does Barbequeen offer BBQ and grilled dishes?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Barbequeen specializes in charcoal-grilled BBQ, double-marinated chicken, kebabs, tikkas, and premium grill platters, freshly prepared with authentic flavours for dine-in and takeaway.",
          },
        },
        {
          "@type": "Question",
          name: "Do you provide outdoor catering services?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Barbequeen Outdoor Catering has successfully completed over 650 events across Tamil Nadu, offering customized menus, live BBQ counters, and professional catering for weddings, parties, and corporate events.",
          },
        },
        {
          "@type": "Question",
          name: "Does Barbequeen offer takeaway and home delivery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Most Barbequeen branches offer takeaway and home delivery. Enjoy authentic biryani, BBQ, mandi, shawarma, and other favourites at home, subject to service availability in your location.",
          },
        },
        {
          "@type": "Question",
          name: "Why do customers choose Barbequeen?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Customers choose Barbequeen for authentic flavours, fresh ingredients, hygienic cooking, friendly service, and consistent quality. Since 1999, we have been serving memorable dining experiences across Tamil Nadu.",
          },
        },
      ],
    },
  ],
};

export const menuPageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": ["Organization", "Restaurant"],
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      legalName: "Nonvee Foods Private Limited",
      url: "https://barbequeen.com/",
      logo: {
        "@type": "ImageObject",
        url: "https://barbequeen.com/images/logo.png",
      },
      hasMenu: { "@id": "https://barbequeen.com/menu#menu" },
    },
    {
      "@type": "WebPage",
      "@id": "https://barbequeen.com/menu#webpage",
      url: "https://barbequeen.com/menu",
      name: "Explore Our Menu | Barbequeen Restaurant",
      description:
        "Explore the complete Barbequeen menu from smoky grills and aromatic biryanis to tandoori specials, Arabian delights, Chinese dishes, and seafood.",
      inLanguage: "en-IN",
      publisher: { "@id": "https://barbequeen.com/#organization" },
      breadcrumb: { "@id": "https://barbequeen.com/menu#breadcrumb" },
      mainEntity: { "@id": "https://barbequeen.com/menu#menu" },
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://barbequeen.com/menu#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://barbequeen.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Menu",
          item: "https://barbequeen.com/menu",
        },
      ],
    },
    {
      "@type": "Menu",
      "@id": "https://barbequeen.com/menu#menu",
      name: "Barbequeen Restaurant Menu",
      description:
        "From smoky grills to aromatic biryanis — discover every flavour Barbequeen has to offer.",
      inLanguage: "en-IN",
      hasMenuSection: [
        {
          "@type": "MenuSection",
          name: "Grill & BBQ",
          hasMenuItem: [
            {
              "@type": "MenuItem",
              name: "Double Marinated Grill Chicken",
              description:
                "Juicy and tender double marinated grill chicken bursting with flavor in every bite! Succulent and perfectly seasoned, this dish can be enjoyed by everyone.",
            },
            {
              "@type": "MenuItem",
              name: "Tandoori Special",
              description:
                "Enjoy the rich, aromatic taste of our Tandoori Special menu. Each dish has been expertly prepared with traditional Indian spices and cooked in our tandoor oven to perfection.",
            },
            {
              "@type": "MenuItem",
              name: "BBQ Platter",
              description:
                "Succulent chicken, marinated to perfection and grilled to a golden crisp, awaits you in our BBQ Chicken Platter. The tender meat, infused with a medley of spices, melts in your mouth.",
            },
          ],
        },
        {
          "@type": "MenuSection",
          name: "Biryani",
          hasMenuItem: [
            {
              "@type": "MenuItem",
              name: "Delicious Biryani",
              description:
                "Our Delicious Biryani menu features a variety of chicken and veggie options, made with authentic spices and the freshest ingredients.",
            },
            {
              "@type": "MenuItem",
              name: "Family Bucket Biryani",
              description:
                "Enjoy the authentic taste of family bucket biryani. Each dish is prepared with tender and flavorful free-range chicken and served up fresh.",
            },
            {
              "@type": "MenuItem",
              name: "Mandi Varieties",
              description:
                "Introduced Mandi Biryani. It's a mix of many flavors that will make your mouth water.",
            },
          ],
        },
        {
          "@type": "MenuSection",
          name: "Specials",
          hasMenuItem: [
            {
              "@type": "MenuItem",
              name: "Arabian Delight",
              description:
                "Experience the exotic flavors of the Middle East with our Arabian Delight menu. Each dish is a tantalizing blend of spices and ingredients.",
            },
          ],
        },
        {
          "@type": "MenuSection",
          name: "Soups",
          hasMenuItem: [
            {
              "@type": "MenuItem",
              name: "Soups",
              description:
                "Enjoy the goodness of our soups menu, crafted with fresh ingredients and flavors that will warm your soul. From creamy bisques to hearty broths.",
            },
          ],
        },
        {
          "@type": "MenuSection",
          name: "Chicken",
          hasMenuItem: [
            {
              "@type": "MenuItem",
              name: "Chicken Boneless Gravy",
              description:
                "Our Chicken boneless Gravy menu is made with tender chicken, rich spices and a variety of mouth-watering flavors.",
            },
            {
              "@type": "MenuItem",
              name: "Chicken Dry",
              description:
                "Tender chicken cooked to perfection with spices that will leave your taste buds wanting more.",
            },
          ],
        },
        {
          "@type": "MenuSection",
          name: "Mutton",
          hasMenuItem: [
            {
              "@type": "MenuItem",
              name: "Mutton Varieties",
              description:
                "Explore our mouth-watering mutton varieties menu! From tender chops to spicy curries.",
            },
          ],
        },
        {
          "@type": "MenuSection",
          name: "Chinese & More",
          hasMenuItem: [
            {
              "@type": "MenuItem",
              name: "Kothu Paratha",
              description:
                "Savor tender meat and veggies in a delicious filling, served piping hot with our delicious spiced parotta.",
            },
            {
              "@type": "MenuItem",
              name: "Chinese Chicken Dry Varieties",
              description:
                "Mouthwatering Chinese Chicken Dry Varieties produced with excellent chicken that has been expertly marinated and grilled.",
            },
            {
              "@type": "MenuItem",
              name: "Fried Rice And Noodles",
              description:
                "Satisfy your cravings with our delicious fried rice and noodles menu! Enjoy authentic flavors and fresh ingredients in every bite.",
            },
          ],
        },
        {
          "@type": "MenuSection",
          name: "Veg & Sides",
          hasMenuItem: [
            {
              "@type": "MenuItem",
              name: "Indian Breads",
              description:
                "From classic naan to stuffed parathas, each bread is made fresh and served hot for the perfect accompaniment to any meal.",
            },
            {
              "@type": "MenuItem",
              name: "Egg Varieties",
              description:
                "Offers a variety of dishes made with fresh ingredients and bursting with flavor.",
            },
            {
              "@type": "MenuItem",
              name: "Vegetable Gravy",
              description:
                "Treat yourself to rich, aromatic gravies that are sure to delight your taste buds. Ideal for a filling and healthful meal.",
            },
            {
              "@type": "MenuItem",
              name: "Vegetable Dry",
              description:
                "Savor the goodness of nature with our Vegetable Dry menu. Packed with flavorful veggies.",
            },
            {
              "@type": "MenuItem",
              name: "Dosai Special",
              description:
                "Features classic masala, crispy paper, savory cheese, and more.",
            },
          ],
        },
        {
          "@type": "MenuSection",
          name: "Seafood",
          hasMenuItem: [
            {
              "@type": "MenuItem",
              name: "Sea Food Dry / Gravy",
              description:
                "Exquisitely prepared seafood dishes that will delight even the most discerning palate.",
            },
          ],
        },
      ],
    },
    {
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What are the most popular dishes at Barbequeen?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our most popular dishes include Double Marinated Grill Chicken, Chicken Dum Biryani, Mutton Biryani, Arabian Mandi, BBQ Platters, Shawarma, and Tandoori Specials, all prepared fresh with authentic recipes.",
          },
        },
        {
          "@type": "Question",
          name: "What type of food does Barbequeen serve?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen offers BBQ grills, authentic dum biryani, Arabian mandi, tandoori, Chinese, Indian, shawarma, seafood, soups, breads, and vegetarian dishes for lunch and dinner.",
          },
        },
        {
          "@type": "Question",
          name: "What makes Barbequeen's biryani special?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our biryani is prepared using premium Seeraga Samba rice, fresh ingredients, aromatic spices, and traditional dum cooking to deliver authentic flavour in every serving.",
          },
        },
        {
          "@type": "Question",
          name: "What is Double Marinated Grill Chicken?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Double Marinated Grill Chicken is Barbequeen's signature BBQ dish, marinated twice with special herbs and spices before being charcoal grilled for a juicy, smoky flavour.",
          },
        },
        {
          "@type": "Question",
          name: "Does Barbequeen serve Arabian Mandi?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Barbequeen serves authentic Arabian Mandi prepared with fragrant rice, tender chicken or mutton, and traditional Middle Eastern spices for a rich dining experience.",
          },
        },
        {
          "@type": "Question",
          name: "Do you have vegetarian dishes?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Our menu includes vegetarian starters, soups, Chinese dishes, rice, noodles, breads, gravies, and desserts, making Barbequeen suitable for every guest.",
          },
        },
        {
          "@type": "Question",
          name: "Do you serve BBQ and tandoori dishes?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. We offer a wide range of charcoal BBQ, kebabs, tikkas, grilled chicken, and traditional tandoori dishes prepared fresh by experienced chefs.",
          },
        },
        {
          "@type": "Question",
          name: "Are your dishes prepared fresh?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Every dish is freshly prepared using quality ingredients, premium spices, and carefully followed recipes to ensure consistent taste and freshness.",
          },
        },
        {
          "@type": "Question",
          name: "Do you offer family meals or bucket biryani?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. We serve Family Bucket Biryani, BBQ platters, combo meals, and sharing portions that are ideal for families, friends, and group dining.",
          },
        },
        {
          "@type": "Question",
          name: "Can I order food for takeaway or delivery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Most Barbequeen branches offer takeaway and home delivery, allowing you to enjoy your favourite biryani, BBQ, mandi, and grilled dishes at home.",
          },
        },
        {
          "@type": "Question",
          name: "Which dishes are best for first-time visitors?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "First-time guests often enjoy our Double Marinated Grill Chicken, Chicken Dum Biryani, Arabian Mandi, BBQ Platters, Shawarma, and Tandoori Specials.",
          },
        },
        {
          "@type": "Question",
          name: "Do you serve lunch and dinner every day?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Barbequeen is open daily from 11:00 AM to 11:00 PM, serving lunch, dinner, takeaway, and delivery across our restaurant locations.",
          },
        },
      ],
    },
  ],
};

export const aboutPageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": ["Organization", "Restaurant"],
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      legalName: "Nonvee Foods Private Limited",
      url: "https://barbequeen.com/",
      logo: {
        "@type": "ImageObject",
        url: "https://barbequeen.com/images/logo.png",
      },
      foundingDate: "1999",
      foundingLocation: {
        "@type": "Place",
        name: "Salem, Tamil Nadu, India",
      },
      slogan: "Serves yummy food like mummy does.",
      description:
        "Crafting premium Indian, Chinese, Tandoori & Grill specialties since 1999. Barbequeen Restaurant offers dine-in, takeaway, online delivery, and outdoor catering services across Tamil Nadu.",
      knowsAbout: [
        "Grill Chicken",
        "Barbecue",
        "Tandoori",
        "Biryani",
        "Indian Cuisine",
        "Chinese Cuisine",
        "Outdoor Catering",
        "Shawarma",
        "Seafood",
      ],
      numberOfLocations: 15,
      sameAs: [
        "https://facebook.com/barbequeenrestaurant",
        "https://instagram.com/barbequeenrestaurant",
      ],
    },
    {
      "@type": "AboutPage",
      "@id": "https://barbequeen.com/about-us#webpage",
      url: "https://barbequeen.com/about-us",
      name: "About Us | Our Story - Barbequeen Restaurant",
      description:
        "Learn about Barbequeen Restaurant's journey since 1999. Crafting premium Indian, Chinese, Tandoori & Grill specialties with over 15 outlets, 35+ expert chefs, and 650+ outdoor catering events.",
      inLanguage: "en-IN",
      publisher: { "@id": "https://barbequeen.com/#organization" },
      about: { "@id": "https://barbequeen.com/#organization" },
      mainEntity: { "@id": "https://barbequeen.com/#organization" },
      breadcrumb: { "@id": "https://barbequeen.com/about-us#breadcrumb" },
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://barbequeen.com/about-us#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://barbequeen.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "About Us",
          item: "https://barbequeen.com/about-us",
        },
      ],
    },
    {
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "When was Barbequeen established?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen was established in 1999 in Salem, Tamil Nadu. For over 25 years, we have been serving authentic BBQ, wood-fire dum biryani, tandoori, and multi-cuisine dishes with a focus on quality, taste, and hospitality.",
          },
        },
        {
          "@type": "Question",
          name: "What makes Barbequeen different from other restaurants?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen combines authentic recipes, fresh ingredients, experienced chefs, and warm hospitality to create memorable dining experiences for families, friends, and food lovers across Tamil Nadu.",
          },
        },
        {
          "@type": "Question",
          name: "What type of cuisine does Barbequeen serve?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen specializes in BBQ grills, authentic dum biryani, tandoori, Arabian mandi, Chinese, Indian, seafood, vegetarian, and non-vegetarian dishes prepared fresh every day.",
          },
        },
        {
          "@type": "Question",
          name: "Why is Barbequeen known for its BBQ?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our signature BBQ is prepared using double-marinated recipes, premium ingredients, and traditional charcoal grilling techniques to deliver rich flavour, tenderness, and consistent quality.",
          },
        },
        {
          "@type": "Question",
          name: "Why do families choose Barbequeen?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Families choose Barbequeen for its spacious seating, hygienic food, welcoming ambience, diverse menu, and friendly service, making every meal comfortable and enjoyable.",
          },
        },
        {
          "@type": "Question",
          name: "Does Barbequeen use fresh ingredients?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Every dish is prepared using carefully selected fresh ingredients, premium spices, and quality meats to maintain authentic taste and consistent food quality.",
          },
        },
        {
          "@type": "Question",
          name: "Who prepares the food at Barbequeen?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our experienced chefs specialize in BBQ, biryani, tandoori, Indian, and Chinese cuisine, following standardized recipes and quality practices developed over more than two decades.",
          },
        },
        {
          "@type": "Question",
          name: "Does Barbequeen offer outdoor catering?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Barbequeen Outdoor Catering has successfully catered more than 650 weddings, corporate events, birthday parties, and family celebrations across Tamil Nadu.",
          },
        },
        {
          "@type": "Question",
          name: "What is Barbequeen's mission?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our mission is to serve delicious food with consistent quality, exceptional hospitality, and memorable dining experiences while preserving authentic flavours that families love.",
          },
        },
        {
          "@type": "Question",
          name: "What is Barbequeen's vision?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen aims to become one of India's most trusted restaurant brands by delivering exceptional food, customer service, and memorable dining experiences across every location.",
          },
        },
        {
          "@type": "Question",
          name: "Is Barbequeen suitable for celebrations?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Barbequeen is a popular choice for birthdays, anniversaries, family gatherings, office parties, and corporate events with customized dining and catering solutions.",
          },
        },
        {
          "@type": "Question",
          name: "Why has Barbequeen been trusted since 1999?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "For over 25 years, Barbequeen has built its reputation through authentic recipes, consistent quality, hygienic food preparation, and a commitment to customer satisfaction across Tamil Nadu.",
          },
        },
      ],
    },
  ],
};

export const contactPageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      legalName: "Nonvee Foods Private Limited",
      url: "https://barbequeen.com/",
      logo: {
        "@type": "ImageObject",
        url: "https://barbequeen.com/images/logo.png",
      },
      foundingDate: "1999",
      email: "feedback@barbequeen.com",
      address: {
        "@type": "PostalAddress",
        streetAddress: "#32/32-1, Valmiki Street, Subramaniya Nagar",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636005",
        addressCountry: "IN",
      },
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+91-95972-28788",
          contactType: "customer service",
          email: "feedback@barbequeen.com",
          areaServed: "IN",
          availableLanguage: ["en", "ta"],
        },
        {
          "@type": "ContactPoint",
          telephone: "+91-95972-28788",
          contactType: "reservations",
          areaServed: "IN",
          availableLanguage: ["en", "ta"],
        },
      ],
      sameAs: [
        "https://facebook.com/BarbequeenRestaurant/",
        "https://instagram.com/barbequeenrestaurant/",
      ],
    },
    {
      "@type": "ContactPage",
      "@id": "https://barbequeen.com/contact-us#contactpage",
      url: "https://barbequeen.com/contact-us",
      name: "Contact Barbequeen Restaurant",
      description:
        "Get in touch with Barbequeen Restaurant for reservations, feedback, catering, and franchise enquiries. Call, email, or visit our outlets across Tamil Nadu.",
      inLanguage: "en-IN",
      about: { "@id": "https://barbequeen.com/#organization" },
      mainEntity: { "@id": "https://barbequeen.com/#organization" },
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://barbequeen.com/contact-us#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://barbequeen.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Contact Us",
          item: "https://barbequeen.com/contact-us",
        },
      ],
    },
    {
      "@type": "FAQPage",
      "@id": "https://barbequeen.com/contact-us#faq",
      mainEntity: [
        {
          "@type": "Question",
          name: "How can I contact Barbequeen Restaurant?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can contact Barbequeen by phone, email, or the online contact form. Our customer support team is available to help with reservations, catering, feedback, and general enquiries.",
          },
        },
        {
          "@type": "Question",
          name: "What is Barbequeen's customer support number?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can reach Barbequeen's customer support team by calling +91 95972 28788 during business hours for reservations, enquiries, and customer assistance.",
          },
        },
        {
          "@type": "Question",
          name: "What is Barbequeen's email address?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "For enquiries, reservations, feedback, or business requests, you can email Barbequeen at feedback@barbequeen.com. Our team will respond as soon as possible.",
          },
        },
        {
          "@type": "Question",
          name: "What are Barbequeen's business hours?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen is open Monday to Sunday from 11:00 AM to 11:00 PM. Visit your nearest outlet for dine-in, takeaway, reservations, and food orders.",
          },
        },
        {
          "@type": "Question",
          name: "Where is Barbequeen's head office located?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen's head office is located in Subramaniya Nagar, Salem, Tamil Nadu. Visit our Contact page for the complete address and directions.",
          },
        },
        {
          "@type": "Question",
          name: "Can I book a table through the Contact page?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. You can contact our team by phone or submit an enquiry through the Contact page to reserve a table at your preferred Barbequeen outlet.",
          },
        },
        {
          "@type": "Question",
          name: "Can I contact Barbequeen for catering enquiries?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Our team can assist with outdoor catering, weddings, corporate events, birthday parties, and family functions. Simply call or submit your enquiry through the Contact page.",
          },
        },
        {
          "@type": "Question",
          name: "How can I share feedback about my dining experience?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We welcome your feedback. You can contact Barbequeen by phone, email, or the online contact form to share your suggestions, compliments, or concerns.",
          },
        },
        {
          "@type": "Question",
          name: "Can I contact Barbequeen for franchise enquiries?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. For franchise opportunities, you can contact our franchise team through the Franchise page or reach us using the contact details provided on our website.",
          },
        },
        {
          "@type": "Question",
          name: "How quickly will Barbequeen respond to my enquiry?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our team aims to respond to enquiries as quickly as possible during business hours. Response times may vary depending on the nature of your request.",
          },
        },
        {
          "@type": "Question",
          name: "Can I visit Barbequeen without a reservation?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Walk-in guests are welcome at all Barbequeen outlets. However, reservations are recommended on weekends and public holidays for faster seating.",
          },
        },
        {
          "@type": "Question",
          name: "Why should I contact Barbequeen directly?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Contacting Barbequeen directly ensures you receive accurate information about reservations, catering, franchise opportunities, outlet locations, menu enquiries, and customer support from our official team.",
          },
        },
      ],
    },
  ],
};

export const cateringPageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      legalName: "Nonvee Foods Private Limited",
      url: "https://barbequeen.com/",
      logo: {
        "@type": "ImageObject",
        url: "https://barbequeen.com/images/logo.png",
      },
    },
    {
      "@type": "WebPage",
      "@id": "https://barbequeen.com/outdoor-catering#webpage",
      url: "https://barbequeen.com/outdoor-catering",
      name: "Outdoor Catering Services | Barbequeen Restaurant",
      description:
        "Professional outdoor catering services by Barbequeen for weddings, receptions, outdoor parties, and festivities across Tamil Nadu.",
      inLanguage: "en-IN",
      isPartOf: { "@id": "https://barbequeen.com/#organization" },
      about: { "@id": "https://barbequeen.com/outdoor-catering#service" },
      mainEntity: { "@id": "https://barbequeen.com/outdoor-catering#service" },
    },
    {
      "@type": "FoodService",
      "@id": "https://barbequeen.com/outdoor-catering#service",
      name: "Barbequeen Outdoor Catering",
      serviceType: "Outdoor Catering",
      category: "Catering Service",
      provider: { "@id": "https://barbequeen.com/#organization" },
      url: "https://barbequeen.com/outdoor-catering",
      description:
        "An outdoor catering service by experienced professionals ensuring hassle-free celebrations. We offer top-quality food and service for weddings, receptions, outdoor parties, and festivities.",
      areaServed: {
        "@type": "State",
        name: "Tamil Nadu",
        sameAs: "https://en.wikipedia.org/wiki/Tamil_Nadu",
      },
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Outdoor Catering Event Packages",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Wedding Catering",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Reception Catering",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Outdoor Parties & Festivities Catering",
            },
          },
        ],
      },
    },
    {
      "@type": "ImageGallery",
      "@id": "https://barbequeen.com/outdoor-catering#gallery",
      name: "Catering Gallery",
      description:
        "Captured setups and presentation moments from outdoor catering events.",
      numberOfItems: 10,
      isPartOf: { "@id": "https://barbequeen.com/outdoor-catering#webpage" },
    },
    {
      "@type": "FAQPage",
      "@id": "https://barbequeen.com/outdoor-catering#faq",
      mainEntity: [
        {
          "@type": "Question",
          name: "What catering services does Barbequeen provide?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen provides outdoor catering for weddings, receptions, birthdays, corporate events, family functions, and special celebrations with customized menus and professional service across Tamil Nadu.",
          },
        },
        {
          "@type": "Question",
          name: "Why choose Barbequeen Outdoor Catering?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen Outdoor Catering combines over 25 years of culinary experience, quality ingredients, experienced chefs, and reliable event management to deliver memorable catering for every occasion.",
          },
        },
        {
          "@type": "Question",
          name: "What events do you cater for?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We cater weddings, receptions, engagement ceremonies, birthday parties, housewarming functions, corporate events, college functions, religious gatherings, and private celebrations of all sizes.",
          },
        },
        {
          "@type": "Question",
          name: "Do you provide live BBQ catering?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Barbequeen offers live BBQ grill counters with freshly prepared grilled chicken, kebabs, tikkas, and other signature barbecue dishes for weddings, parties, and corporate events.",
          },
        },
        {
          "@type": "Question",
          name: "Can I customize the catering menu?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Our catering menus can be customized based on your event, guest count, cuisine preferences, and budget, including biryani, BBQ, tandoori, Indian, Chinese, and vegetarian dishes.",
          },
        },
        {
          "@type": "Question",
          name: "Do you provide catering across Tamil Nadu?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Barbequeen Outdoor Catering serves customers across Tamil Nadu for weddings, family functions, corporate events, and large outdoor celebrations.",
          },
        },
        {
          "@type": "Question",
          name: "How many events has Barbequeen catered?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen has successfully completed more than 650 outdoor catering events, earning the trust of families, businesses, and event organizers across Tamil Nadu.",
          },
        },
        {
          "@type": "Question",
          name: "Do you provide catering for corporate events?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. We offer professional catering for corporate meetings, office celebrations, product launches, conferences, employee events, and business gatherings with customized menu options.",
          },
        },
        {
          "@type": "Question",
          name: "Do you provide vegetarian and non-vegetarian catering?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. We offer both vegetarian and non-vegetarian catering with a wide selection of biryani, BBQ, tandoori, Chinese, Indian, seafood, and vegetarian specialties.",
          },
        },
        {
          "@type": "Question",
          name: "How can I book Barbequeen Outdoor Catering?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can book Barbequeen Outdoor Catering by submitting the enquiry form or contacting our catering team by phone or email to discuss your event requirements.",
          },
        },
        {
          "@type": "Question",
          name: "How far in advance should I book catering?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We recommend booking your catering as early as possible, especially for weddings, festivals, and weekends, to ensure your preferred event date and menu are available.",
          },
        },
        {
          "@type": "Question",
          name: "What makes Barbequeen Catering different?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen is known for authentic recipes, fresh ingredients, experienced chefs, customized menus, professional service, and a commitment to making every event successful.",
          },
        },
      ],
    },
  ],
};

export const franchisePageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": ["Organization", "Restaurant"],
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      legalName: "Nonvee Foods Private Limited",
      url: "https://barbequeen.com/",
      logo: {
        "@type": "ImageObject",
        url: "https://barbequeen.com/images/logo.png",
      },
      address: {
        "@type": "PostalAddress",
        streetAddress: "# 32/32-1, Valmiki Street",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636005",
        addressCountry: "IN",
      },
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "+919087222264",
        contactType: "franchise enquiry",
        email: "franchise.barbequeen@nonveefoods.com",
        availableLanguage: ["en", "ta"],
        hoursAvailable: {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
          opens: "10:00",
          closes: "18:00",
        },
      },
    },
    {
      "@type": "WebPage",
      "@id": "https://barbequeen.com/franchise#webpage",
      url: "https://barbequeen.com/franchise",
      name: "Franchise Opportunities | Barbequeen Restaurant",
      description:
        "Partner with Barbequeen Restaurant. Apply for a restaurant franchise opportunity and bring Salem's signature taste to your city.",
      inLanguage: "en-IN",
      publisher: { "@id": "https://barbequeen.com/#organization" },
      breadcrumb: { "@id": "https://barbequeen.com/franchise#breadcrumb" },
      about: { "@id": "https://barbequeen.com/franchise#service" },
      mainEntity: { "@id": "https://barbequeen.com/franchise#service" },
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://barbequeen.com/franchise#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://barbequeen.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Franchise",
          item: "https://barbequeen.com/franchise",
        },
      ],
    },
    {
      "@type": "Service",
      "@id": "https://barbequeen.com/franchise#service",
      name: "Barbequeen Restaurant Franchise Partnership",
      serviceType: "Franchise Business Opportunity",
      category: "Restaurant Franchise",
      provider: { "@id": "https://barbequeen.com/#organization" },
      url: "https://barbequeen.com/franchise",
      description:
        "Franchise opportunity to open a Barbequeen Restaurant branch in your city. Full operational support, brand heritage, and signature barbecue and biryani menu.",
      areaServed: {
        "@type": "Country",
        name: "India",
      },
    },
    {
      "@type": "FAQPage",
      "@id": "https://barbequeen.com/franchise#faq",
      mainEntity: [
        {
          "@type": "Question",
          name: "How can I start a Barbequeen franchise?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Starting a Barbequeen franchise is simple. Submit the franchise enquiry form, share your preferred location and business details, and our franchise team will contact you to discuss the next steps.",
          },
        },
        {
          "@type": "Question",
          name: "Why choose a Barbequeen franchise?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen has been serving customers since 1999 and has built a trusted reputation for BBQ, biryani, and family dining. Our proven business model and operational support help franchise partners grow confidently.",
          },
        },
        {
          "@type": "Question",
          name: "Who can apply for a Barbequeen franchise?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Entrepreneurs, business owners, investors, and hospitality professionals interested in operating a restaurant business can apply for a Barbequeen franchise. Previous food industry experience is helpful but not mandatory.",
          },
        },
        {
          "@type": "Question",
          name: "Do I need restaurant experience to own a franchise?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "No. Restaurant experience is not mandatory. Our team provides guidance throughout the franchise process, helping partners understand operations and brand standards.",
          },
        },
        {
          "@type": "Question",
          name: "Does Barbequeen provide franchise support?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Barbequeen supports franchise partners with business guidance, operational assistance, brand standards, and launch planning to help establish a successful restaurant.",
          },
        },
        {
          "@type": "Question",
          name: "Can I choose my preferred franchise location?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. You can mention your preferred city or location in the franchise application. Our team will evaluate the market potential and location suitability before approval.",
          },
        },
        {
          "@type": "Question",
          name: "What franchise models does Barbequeen offer?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen offers different franchise opportunities based on business requirements and operational needs. Our franchise team will recommend the most suitable model during the consultation process.",
          },
        },
        {
          "@type": "Question",
          name: "How long does the franchise approval process take?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "The timeline depends on location evaluation, documentation, and project planning. Once your enquiry is received, the franchise team will guide you through each stage of the approval process.",
          },
        },
        {
          "@type": "Question",
          name: "What type of locations are suitable for a Barbequeen franchise?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "High-street locations, stand-alone buildings, malls, and food courts with good customer visibility and accessibility are generally preferred for a Barbequeen franchise.",
          },
        },
        {
          "@type": "Question",
          name: "How do I contact the Barbequeen franchise team?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can submit the online franchise enquiry form or contact the Barbequeen franchise team directly using the phone number or email provided on the Franchise page.",
          },
        },
        {
          "@type": "Question",
          name: "Is Barbequeen expanding across Tamil Nadu and India?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Barbequeen continues to expand its restaurant network through company-owned and franchise outlets, offering opportunities for entrepreneurs who want to grow with an established food brand.",
          },
        },
        {
          "@type": "Question",
          name: "Why invest in a Barbequeen franchise?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "A Barbequeen franchise offers the advantage of an established restaurant brand, a loyal customer base, standardized operations, and ongoing business support, making it an attractive opportunity for long-term growth.",
          },
        },
      ],
    },
  ],
};

export const eventsPageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      legalName: "Nonvee Foods Private Limited",
      url: "https://barbequeen.com/",
      logo: {
        "@type": "ImageObject",
        url: "https://barbequeen.com/images/logo.png",
      },
    },
    {
      "@type": "WebPage",
      "@id": "https://barbequeen.com/events#webpage",
      url: "https://barbequeen.com/events",
      name: "Party Venue & Event Celebrations | Barbequeen Restaurant",
      description:
        "Spacious party venue and well-equipped party hall at Barbequeen Restaurant for hosting birthday parties, anniversary celebrations, and customized gatherings.",
      inLanguage: "en-IN",
      publisher: { "@id": "https://barbequeen.com/#organization" },
      about: { "@id": "https://barbequeen.com/events#service" },
      mainEntity: { "@id": "https://barbequeen.com/events#service" },
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://barbequeen.com/events#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://barbequeen.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Events & Celebrations",
          item: "https://barbequeen.com/events",
        },
      ],
    },
    {
      "@type": "Service",
      "@id": "https://barbequeen.com/events#service",
      name: "Barbequeen Party Hall & Event Venue",
      serviceType: "Party Venue & Event Hosting",
      category: "Event Venue & Catering",
      provider: { "@id": "https://barbequeen.com/#organization" },
      url: "https://barbequeen.com/events",
      description:
        "Spacious and well-equipped party hall at Barbequeen Restaurant to host birthdays, anniversaries, and custom private celebrations with full food and event support.",
      areaServed: {
        "@type": "State",
        name: "Tamil Nadu",
      },
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Event Hosting Services",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Birthday Party Hosting",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Anniversary Celebration Hosting",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Customized Private Gatherings",
            },
          },
        ],
      },
    },
    {
      "@type": "ImageGallery",
      "@id": "https://barbequeen.com/events#birthday-gallery",
      name: "Birthday Celebration Gallery",
      description:
        "Captured moments and setups from birthday parties at Barbequeen Restaurant.",
      numberOfItems: 8,
      isPartOf: { "@id": "https://barbequeen.com/events#webpage" },
    },
    {
      "@type": "ImageGallery",
      "@id": "https://barbequeen.com/events#anniversary-gallery",
      name: "Anniversary Celebration Gallery",
      description:
        "Captured moments and setups from anniversary celebrations at Barbequeen Restaurant.",
      numberOfItems: 5,
      isPartOf: { "@id": "https://barbequeen.com/events#webpage" },
    },
  ],
};

export const awardsPageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      legalName: "Nonvee Foods Private Limited",
      url: "https://barbequeen.com/",
      logo: {
        "@type": "ImageObject",
        url: "https://barbequeen.com/images/logo.png",
      },
      foundingDate: "1999",
      award: [
        "25+ Years of Culinary Excellence in Tamil Nadu (1999–2025)",
        "Best Barbecue & Charcoal Grill Restaurant — Salem & Western TN",
        "Excellence in Customer Satisfaction & Family Dining",
      ],
      sameAs: [
        "https://facebook.com/BarbequeenRestaurant/",
        "https://instagram.com/barbequeenrestaurant/",
      ],
    },
    {
      "@type": "CollectionPage",
      "@id": "https://barbequeen.com/awards-achievements#webpage",
      url: "https://barbequeen.com/awards-achievements",
      name: "Awards & Achievements | Barbequeen Restaurant",
      description:
        "The awards and achievements earned by Barbequeen Restaurant since 1999 — recognition for our grills, biryani, service, and consistent quality across Tamil Nadu.",
      inLanguage: "en-IN",
      publisher: { "@id": "https://barbequeen.com/#organization" },
      about: { "@id": "https://barbequeen.com/#organization" },
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://barbequeen.com/awards-achievements#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://barbequeen.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Awards & Achievements",
          item: "https://barbequeen.com/awards-achievements",
        },
      ],
    },
  ],
};

export const expressPageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      legalName: "Nonvee Foods Private Limited",
      url: "https://barbequeen.com/",
      logo: {
        "@type": "ImageObject",
        url: "https://barbequeen.com/images/logo.png",
      },
    },
    {
      "@type": "WebPage",
      "@id": "https://barbequeen.com/barbequeen-express#webpage",
      url: "https://barbequeen.com/barbequeen-express",
      name: "Barbequeen Express | Grill On The Go & Live Cooking",
      description:
        "Live cooking, food trucks, and premium grill catering for your private events by Barbequeen Express across Salem and Tamil Nadu.",
      inLanguage: "en-IN",
      publisher: { "@id": "https://barbequeen.com/#organization" },
      about: { "@id": "https://barbequeen.com/barbequeen-express#service" },
      mainEntity: {
        "@id": "https://barbequeen.com/barbequeen-express#service",
      },
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://barbequeen.com/barbequeen-express#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://barbequeen.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Barbequeen Express",
          item: "https://barbequeen.com/barbequeen-express",
        },
      ],
    },
    {
      "@type": "FoodService",
      "@id": "https://barbequeen.com/barbequeen-express#service",
      name: "Barbequeen Express - Grill On The Go",
      serviceType: "Food Truck & Live Grill Catering",
      category: "Live Cooking Catering",
      provider: { "@id": "https://barbequeen.com/#organization" },
      url: "https://barbequeen.com/barbequeen-express",
      description:
        "Live cooking, food truck experience, and premium grill catering brought directly to your venue for private events, outdoor parties, and celebrations.",
      areaServed: [
        {
          "@type": "City",
          name: "Salem",
        },
        {
          "@type": "State",
          name: "Tamil Nadu",
        },
      ],
      hoursAvailable: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "https://schema.org/Monday",
          "https://schema.org/Tuesday",
          "https://schema.org/Wednesday",
          "https://schema.org/Thursday",
          "https://schema.org/Friday",
          "https://schema.org/Saturday",
          "https://schema.org/Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "ImageGallery",
      "@id": "https://barbequeen.com/barbequeen-express#gallery",
      name: "Express Gallery",
      description:
        "Captured food truck and setup moments from live cooking events.",
      numberOfItems: 5,
      isPartOf: { "@id": "https://barbequeen.com/barbequeen-express#webpage" },
    },
  ],
};

export const funActivitiesPageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      legalName: "Nonvee Foods Private Limited",
      url: "https://barbequeen.com/",
      logo: {
        "@type": "ImageObject",
        url: "https://barbequeen.com/images/logo.png",
      },
      foundingDate: "1999",
      sameAs: [
        "https://facebook.com/BarbequeenRestaurant/",
        "https://instagram.com/barbequeenrestaurant/",
      ],
    },
    {
      "@type": "WebPage",
      "@id": "https://barbequeen.com/fun-activities#webpage",
      url: "https://barbequeen.com/fun-activities",
      name: "Fun Activities at Barbequeen Restaurant",
      description:
        "Discover the fun activities at Barbequeen Restaurant — games, family entertainment, and special events that make every visit more than just a great meal.",
      inLanguage: "en-IN",
      publisher: { "@id": "https://barbequeen.com/#organization" },
      about: { "@id": "https://barbequeen.com/#organization" },
      mainEntity: {
        "@type": "ItemList",
        name: "Fun Activities at Barbequeen",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Live Tabletop Grill Experience",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Birthday & Special Event Celebrations",
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Family & Group Dining Games",
          },
          {
            "@type": "ListItem",
            position: 4,
            name: "Kids' Entertainment & Creative Corner",
          },
        ],
      },
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://barbequeen.com/fun-activities#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://barbequeen.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Fun Activities",
          item: "https://barbequeen.com/fun-activities",
        },
      ],
    },
  ],
};

export const blogListPageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      url: "https://barbequeen.com/",
      logo: {
        "@type": "ImageObject",
        url: "https://barbequeen.com/images/logo.png",
      },
      foundingDate: "1999",
      sameAs: [
        "https://facebook.com/BarbequeenRestaurant/",
        "https://instagram.com/barbequeenrestaurant/",
      ],
    },
    {
      "@type": "Blog",
      "@id": "https://barbequeen.com/blog#blog",
      url: "https://barbequeen.com/blog",
      name: "Barbequeen Blog",
      description:
        "Recipes, grill and barbecue tips, biryani stories, offers, and news from Barbequeen Restaurant across Salem, Coimbatore, Erode, Krishnagiri and Hosur.",
      inLanguage: "en-IN",
      publisher: { "@id": "https://barbequeen.com/#organization" },
      blogPost: [
        {
          "@type": "BlogPosting",
          headline: "Best Biryani in Salem",
          url: "https://barbequeen.com/blog/best-biryani-in-salem",
        },
        {
          "@type": "BlogPosting",
          headline: "Best Biryani in Coimbatore",
          url: "https://barbequeen.com/blog/best-biryani-in-coimbatore",
        },
        {
          "@type": "BlogPosting",
          headline: "Best Chicken Biryani in Coimbatore",
          url: "https://barbequeen.com/blog/best-chicken-biryani-coimbatore",
        },
        {
          "@type": "BlogPosting",
          headline: "Unlimited Mandi Biryani at Barbequeen",
          url: "https://barbequeen.com/blog/mandi-biryani",
        },
        {
          "@type": "BlogPosting",
          headline: "Chicken Maharaja at Barbequeen",
          url: "https://barbequeen.com/blog/chicken-maharaja",
        },
        {
          "@type": "BlogPosting",
          headline: "Top 10 Best Barbeque Starters in Salem",
          url: "https://barbequeen.com/blog/best-barbeque-starters-in-salem",
        },
        {
          "@type": "BlogPosting",
          headline: "Best Grill and Tandoori Near Me",
          url: "https://barbequeen.com/blog/best-grill-and-tandoori-near-me",
        },
        {
          "@type": "BlogPosting",
          headline: "Barbequeen Restaurant Near Me",
          url: "https://barbequeen.com/blog/barbequeen-restaurant-near-me",
        },
        {
          "@type": "BlogPosting",
          headline: "Best Barbeque & Family Restaurant Near Me",
          url: "https://barbequeen.com/blog/barbeque-family-restaurant-near-me",
        },
        {
          "@type": "BlogPosting",
          headline: "Best Family Restaurant in Erode",
          url: "https://barbequeen.com/blog/best-family-restaurant-erode",
        },
        {
          "@type": "BlogPosting",
          headline: "Best Family Restaurant in Salem",
          url: "https://barbequeen.com/blog/best-restaurant-in-salem",
        },
        {
          "@type": "BlogPosting",
          headline: "Wednesday Super Saver Combo at Barbequeen – ₹879",
          url: "https://barbequeen.com/blog/wednesday-super-saver-combo",
        },
        {
          "@type": "BlogPosting",
          headline: "Ayudha Pooja Celebration at Barbequeen",
          url: "https://barbequeen.com/blog/barbequeen-ayudha-pooja",
        },
        {
          "@type": "BlogPosting",
          headline: "Veg Biryani Service at Gugai Mariamman Temple Festival",
          url: "https://barbequeen.com/blog/gugai-annadhanam",
        },
      ],
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://barbequeen.com/blog#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://barbequeen.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Blog",
          item: "https://barbequeen.com/blog",
        },
      ],
    },
    {
      "@type": "FAQPage",
      "@id": "https://barbequeen.com/blog#faq",
      mainEntity: [
        {
          "@type": "Question",
          name: "What topics does the Barbequeen Blog cover?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "The Barbequeen Blog shares articles about BBQ, authentic biryani, grilling tips, restaurant updates, catering ideas, recipes, and dining experiences to help food lovers discover new flavours and expert insights.",
          },
        },
        {
          "@type": "Question",
          name: "Why should I read the Barbequeen Blog?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our blog provides expert food tips, BBQ techniques, recipe inspiration, catering advice, and restaurant updates to help you enjoy authentic flavours and make informed dining choices.",
          },
        },
        {
          "@type": "Question",
          name: "Does the Barbequeen Blog share BBQ and grilling tips?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Our blog features BBQ techniques, grilling methods, cooking tips, and chef-inspired insights to help readers understand the art of authentic barbecue cooking.",
          },
        },
        {
          "@type": "Question",
          name: "Can I learn about authentic biryani from the blog?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. We publish articles about dum biryani, traditional cooking methods, premium ingredients, regional flavours, and tips for enjoying authentic biryani.",
          },
        },
        {
          "@type": "Question",
          name: "Does the blog include catering and event ideas?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. The Barbequeen Blog shares planning tips for weddings, birthday parties, corporate events, and outdoor catering to help make every celebration memorable.",
          },
        },
        {
          "@type": "Question",
          name: "Are new articles published regularly?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. We regularly publish new articles featuring food trends, restaurant news, recipes, seasonal specials, BBQ tips, and dining inspiration for our readers.",
          },
        },
        {
          "@type": "Question",
          name: "Who writes the Barbequeen Blog?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our articles are created by the Barbequeen team using insights from experienced chefs, food experts, and restaurant professionals to provide practical and reliable information.",
          },
        },
        {
          "@type": "Question",
          name: "Can I discover Barbequeen's signature dishes through the blog?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Our blog highlights signature dishes, BBQ specials, dum biryani, tandoori favourites, and seasonal menu recommendations to help you explore the best of Barbequeen.",
          },
        },
        {
          "@type": "Question",
          name: "Does the blog help me choose what to order?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Our articles introduce popular dishes, flavour profiles, chef recommendations, and dining suggestions, making it easier to choose the right meal for every occasion.",
          },
        },
        {
          "@type": "Question",
          name: "Is the Barbequeen Blog useful for food lovers?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely. Whether you enjoy BBQ, biryani, grilling, or family dining, our blog offers useful tips, recipes, and food stories to enhance your dining experience.",
          },
        },
        {
          "@type": "Question",
          name: "Can I find restaurant updates on the blog?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. The Barbequeen Blog features restaurant news, outlet updates, special offers, seasonal menus, and brand announcements to keep customers informed.",
          },
        },
        {
          "@type": "Question",
          name: "Why is the Barbequeen Blog a trusted food resource?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our blog is based on Barbequeen's experience since 1999, sharing practical knowledge, authentic recipes, and real restaurant expertise to help readers enjoy great food with confidence.",
          },
        },
      ],
    },
  ],
};

export const galleryPageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      legalName: "Nonvee Foods Private Limited",
      url: "https://barbequeen.com/",
      logo: {
        "@type": "ImageObject",
        url: "https://barbequeen.com/images/logo.png",
      },
      foundingDate: "1999",
      sameAs: [
        "https://facebook.com/BarbequeenRestaurant/",
        "https://instagram.com/barbequeenrestaurant/",
      ],
    },
    {
      "@type": "ImageGallery",
      "@id": "https://barbequeen.com/outlet-gallery#gallery",
      url: "https://barbequeen.com/outlet-gallery",
      name: "Barbequeen Outlet Gallery",
      description:
        "Photo gallery of Barbequeen Restaurant outlets across Salem, Coimbatore, Erode, Krishnagiri and Hosur — dining spaces, live grills, and signature dishes.",
      inLanguage: "en-IN",
      publisher: { "@id": "https://barbequeen.com/#organization" },
      associatedMedia: [
        {
          "@type": "ImageObject",
          url: "https://barbequeen.com/public/images/outlet_gallery/salem-five-roads.jpg",
          contentUrl:
            "https://barbequeen.com/public/images/outlet_gallery/salem-five-roads.jpg",
          name: "Barbequeen Five Roads Outlet, Salem",
          caption: "Barbequeen outlet at Five Roads (Junction), Salem",
        },
        {
          "@type": "ImageObject",
          url: "https://barbequeen.com/public/images/outlet_gallery/salem-fairlands.jpg",
          contentUrl:
            "https://barbequeen.com/public/images/outlet_gallery/salem-fairlands.jpg",
          name: "Barbequeen Fairlands Outlet, Salem",
          caption: "Barbequeen outlet at Fairlands, Salem",
        },
        {
          "@type": "ImageObject",
          url: "https://barbequeen.com/public/images/outlet_gallery/coimbatore-saibaba-colony.jpg",
          contentUrl:
            "https://barbequeen.com/public/images/outlet_gallery/coimbatore-saibaba-colony.jpg",
          name: "Barbequeen Saibaba Colony Outlet, Coimbatore",
          caption: "Barbequeen outlet at Saibaba Colony, Coimbatore",
        },
        {
          "@type": "ImageObject",
          url: "https://barbequeen.com/public/images/outlet_gallery/erode-perundurai-road.jpg",
          contentUrl:
            "https://barbequeen.com/public/images/outlet_gallery/erode-perundurai-road.jpg",
          name: "Barbequeen Erode Outlet",
          caption: "Barbequeen outlet on Perundurai Road, Erode",
        },
        {
          "@type": "ImageObject",
          url: "https://barbequeen.com/public/images/outlet_gallery/krishnagiri-highway.jpg",
          contentUrl:
            "https://barbequeen.com/public/images/outlet_gallery/krishnagiri-highway.jpg",
          name: "Barbequeen Krishnagiri Outlet",
          caption:
            "Barbequeen outlet on the Chennai–Bengaluru highway, Krishnagiri",
        },
      ],
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://barbequeen.com/outlet-gallery#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://barbequeen.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Outlet Gallery",
          item: "https://barbequeen.com/outlet-gallery",
        },
      ],
    },
    {
      "@type": "FAQPage",
      "@id": "https://barbequeen.com/outlet-gallery#faq",
      mainEntity: [
        {
          "@type": "Question",
          name: "What can I see in the Barbequeen Outlet Gallery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "The Barbequeen Outlet Gallery showcases our restaurant interiors, dining spaces, BBQ stations, signature dishes, family seating, and event setups, helping guests explore the dining experience before visiting.",
          },
        },
        {
          "@type": "Question",
          name: "Why should I view the Outlet Gallery before visiting?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our gallery gives you a preview of the restaurant ambience, seating, food presentation, and overall dining experience, making it easier to choose the right Barbequeen outlet for your visit.",
          },
        },
        {
          "@type": "Question",
          name: "Do the gallery photos show actual Barbequeen outlets?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. The Outlet Gallery features photographs of real Barbequeen restaurants, showcasing our interiors, dining areas, signature dishes, and customer-friendly atmosphere across different locations.",
          },
        },
        {
          "@type": "Question",
          name: "Can I view the dining ambience before booking a table?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Our Outlet Gallery lets you explore the restaurant ambience, seating arrangements, and dining environment before making a reservation or visiting your nearest Barbequeen outlet.",
          },
        },
        {
          "@type": "Question",
          name: "Does every Barbequeen outlet have a family-friendly atmosphere?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Every Barbequeen outlet is designed with comfortable seating, a welcoming ambience, and spacious dining areas, making it suitable for families, friends, and group gatherings.",
          },
        },
        {
          "@type": "Question",
          name: "Can I see photos of Barbequeen's signature dishes?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. The gallery features popular dishes including BBQ grills, Chicken Dum Biryani, Tandoori Specials, Arabian Mandi, and other customer favourites served at Barbequeen.",
          },
        },
        {
          "@type": "Question",
          name: "Does the gallery include photos of private events and celebrations?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. The Outlet Gallery includes selected photos of birthday celebrations, family gatherings, and special dining moments hosted at Barbequeen restaurants.",
          },
        },
        {
          "@type": "Question",
          name: "Are the gallery images regularly updated?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. We periodically update our gallery with new restaurant interiors, food photography, customer experiences, and special event highlights from Barbequeen outlets.",
          },
        },
        {
          "@type": "Question",
          name: "Can I choose a Barbequeen outlet based on the gallery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. The gallery helps you compare the ambience and dining spaces across Barbequeen outlets, making it easier to choose the location that best suits your family, friends, or special occasion.",
          },
        },
        {
          "@type": "Question",
          name: "Where can I find more photos of Barbequeen restaurants?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can explore more restaurant photos, food images, and dining experiences in the Barbequeen Outlet Gallery and on our official social media channels.",
          },
        },
        {
          "@type": "Question",
          name: "Do the gallery photos reflect the actual dining experience?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Our gallery highlights the real ambience, signature dishes, hospitality, and dining environment that guests can expect when visiting any Barbequeen outlet.",
          },
        },
        {
          "@type": "Question",
          name: "How can I visit the Barbequeen outlet shown in the gallery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Simply visit our Outlets page to find the branch address, contact details, and directions for the Barbequeen restaurant featured in the gallery.",
          },
        },
      ],
    },
  ],
};

export const outletsPageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      legalName: "Nonvee Foods Private Limited",
      url: "https://barbequeen.com/",
      logo: {
        "@type": "ImageObject",
        url: "https://barbequeen.com/images/logo.png",
      },
      foundingDate: "1999",
      sameAs: [
        "https://facebook.com/BarbequeenRestaurant/",
        "https://instagram.com/barbequeenrestaurant/",
      ],
    },
    {
      "@type": "CollectionPage",
      "@id": "https://barbequeen.com/outlets#webpage",
      url: "https://barbequeen.com/outlets",
      name: "Our Outlets | Barbequeen Restaurant",
      description:
        "Find your nearest Barbequeen outlet across Salem, Coimbatore, Erode, Hosur, Thanjavur, and other locations. Phone numbers, addresses, and hours for dine-in, takeaway, and delivery.",
      inLanguage: "en-IN",
      publisher: { "@id": "https://barbequeen.com/#organization" },
      about: { "@id": "https://barbequeen.com/#organization" },
      mainEntity: { "@id": "https://barbequeen.com/outlets#outlet-list" },
    },
    {
      "@type": "ItemList",
      "@id": "https://barbequeen.com/outlets#outlet-list",
      name: "Barbequeen Restaurant Outlets",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#salem-five-roads",
            name: "Barbequeen - Five Roads, Salem",
            url: "https://barbequeen.com/outlets#salem-five-roads",
            telephone: "+919659184555",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress: "Reliance Mall, Junction Main Rd",
              addressLocality: "Salem",
              addressRegion: "Tamil Nadu",
              postalCode: "636004",
              addressCountry: "IN",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 2,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#salem-sona",
            name: "Barbequeen - Sona, Salem",
            url: "https://barbequeen.com/outlets#salem-sona",
            telephone: "+919659174555",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "Junction Main Rd, Near Sona College, Subramania Nagar",
              addressLocality: "Salem",
              addressRegion: "Tamil Nadu",
              postalCode: "636005",
              addressCountry: "IN",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 3,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#salem-fairlands",
            name: "Barbequeen - Fairlands, Salem",
            url: "https://barbequeen.com/outlets#salem-fairlands",
            telephone: "+919003610005",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress: "31, Greenways Rd, Sinthampalayam, Fairlands",
              addressLocality: "Salem",
              addressRegion: "Tamil Nadu",
              postalCode: "636016",
              addressCountry: "IN",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 4,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#salem-hasthampatty",
            name: "Barbequeen - Hasthampatty, Salem",
            url: "https://barbequeen.com/outlets#salem-hasthampatty",
            telephone: "+919894055651",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress: "No:43, N.C.A.S. Building, Hasthampatti Main Rd",
              addressLocality: "Salem",
              addressRegion: "Tamil Nadu",
              postalCode: "636007",
              addressCountry: "IN",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 5,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#salem-gugai",
            name: "Barbequeen - Gugai, Salem",
            url: "https://barbequeen.com/outlets#salem-gugai",
            telephone: "+919003344900",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress: "No. 402, Trichy Main Rd, Sendarapatti, Gugai",
              addressLocality: "Salem",
              addressRegion: "Tamil Nadu",
              postalCode: "636006",
              addressCountry: "IN",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 6,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#salem-cherry-road",
            name: "Barbequeen - Cherry Road, Salem",
            url: "https://barbequeen.com/outlets#salem-cherry-road",
            telephone: "+919659204555",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "223, Cherry Rd, Near Eswaran Temple, Opp. Petrol Pump",
              addressLocality: "Salem",
              addressRegion: "Tamil Nadu",
              postalCode: "636001",
              addressCountry: "IN",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 7,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#salem-seelanaikenpati",
            name: "Barbequeen - Seelanaikenpati, Salem",
            url: "https://barbequeen.com/outlets#salem-seelanaikenpati",
            telephone: "+919659204555",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "Trichy Main Rd, Annamali Nagar, M G R Nagar, Seelanaickenpatti",
              addressLocality: "Salem",
              addressRegion: "Tamil Nadu",
              postalCode: "636201",
              addressCountry: "IN",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 8,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#salem-modern-theatre",
            name: "Barbequeen - Modern Theatre, Salem",
            url: "https://barbequeen.com/outlets#salem-modern-theatre",
            telephone: "+919087222285",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "61, Yercaud Main Rd, Near Modern Theatre, Chinnakollapatty",
              addressLocality: "Salem",
              addressRegion: "Tamil Nadu",
              postalCode: "636008",
              addressCountry: "IN",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 9,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#erode",
            name: "Barbequeen - Erode",
            url: "https://barbequeen.com/outlets#erode",
            telephone: "+919003760005",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "9, 10, Perundurai Rd, Opp. Sudha Hospital, V Chatram",
              addressLocality: "Erode",
              addressRegion: "Tamil Nadu",
              postalCode: "638011",
              addressCountry: "IN",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 10,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#coimbatore-saibaba-colony",
            name: "Barbequeen - Saibaba Colony, Coimbatore",
            url: "https://barbequeen.com/outlets#coimbatore-saibaba-colony",
            telephone: "+919944744833",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "14, Alagesan Rd, Nesavaalar Colony, Saibaba Colony",
              addressLocality: "Coimbatore",
              addressRegion: "Tamil Nadu",
              postalCode: "641011",
              addressCountry: "IN",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 11,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#hosur",
            name: "Barbequeen - Hosur",
            url: "https://barbequeen.com/outlets#hosur",
            telephone: "+919087222264",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress: "SH 17, Avalapalli Hudco",
              addressLocality: "Hosur",
              addressRegion: "Tamil Nadu",
              postalCode: "635109",
              addressCountry: "IN",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 12,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#kallakurichi",
            name: "Barbequeen - Kallakurichi",
            url: "https://barbequeen.com/outlets#kallakurichi",
            telephone: "+919943440022",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress: "PXQC+5G3, Kottaimedu",
              addressLocality: "Kallakurichi",
              addressRegion: "Tamil Nadu",
              postalCode: "606202",
              addressCountry: "IN",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 13,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#tiruchengode",
            name: "Barbequeen - Tiruchengode",
            url: "https://barbequeen.com/outlets#tiruchengode",
            telephone: "+919965597979",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "1/1 A, Tiruchengode - Paramathi - Velur Rd, CHB Colony, Mahadhavapuram",
              addressLocality: "Tiruchengode",
              addressRegion: "Tamil Nadu",
              postalCode: "637211",
              addressCountry: "IN",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 14,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#namakkal",
            name: "Barbequeen - Namakkal",
            url: "https://barbequeen.com/outlets#namakkal",
            telephone: "+919559845598",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "420/152C, Salem - Namakkal Rd, Near BEA, R.P Pudur",
              addressLocality: "Namakkal",
              addressRegion: "Tamil Nadu",
              postalCode: "637001",
              addressCountry: "IN",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 15,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#harur",
            name: "Barbequeen - Harur",
            url: "https://barbequeen.com/outlets#harur",
            telephone: "+919443366880",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress: "Sree Vaari Mini Mahal, Salem ByPass Road, 03",
              addressLocality: "Harur",
              addressRegion: "Tamil Nadu",
              postalCode: "636903",
              addressCountry: "IN",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 16,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#thanjavur",
            name: "Barbequeen - Thanjavur",
            url: "https://barbequeen.com/outlets#thanjavur",
            telephone: "+917373773232",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress: "Near Meenakshi Hospital, New Bus Stand",
              addressLocality: "Thanjavur",
              addressRegion: "Tamil Nadu",
              postalCode: "613005",
              addressCountry: "IN",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 17,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#krishnagiri",
            name: "Barbequeen - Krishnagiri",
            url: "https://barbequeen.com/outlets#krishnagiri",
            telephone: "+919360866880",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "Chennai Exit Point, Chennai Bengaluru Highway, Near K.P.N Lakshmi Mahal",
              addressLocality: "Krishnagiri",
              addressRegion: "Tamil Nadu",
              postalCode: "635001",
              addressCountry: "IN",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 18,
          item: {
            "@type": "Restaurant",
            "@id": "https://barbequeen.com/outlets#pudukkottai",
            name: "Barbequeen - Pudukkottai",
            url: "https://barbequeen.com/best-restaurant-in-pudukkottai",
            telephone: "+918675795788",
            priceRange: "₹₹",
            servesCuisine: [
              "Barbecue",
              "Grill",
              "Tandoori",
              "Arabian",
              "Biryani",
              "North Indian",
              "Chinese",
              "Chettinad",
              "Mandi",
            ],
            parentOrganization: {
              "@id": "https://barbequeen.com/#organization",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "Plot No. 3 B/3, Door No. 1665, Nalan Food Products, SIPCOT Industrial Park",
              addressLocality: "Pudukkottai",
              addressRegion: "Tamil Nadu",
              postalCode: "622002",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: "10.3833",
              longitude: "78.8001",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ],
              opens: "11:00",
              closes: "23:00",
            },
          },
        },
      ],
    },
    {
      "@type": "FAQPage",
      "@id": "https://barbequeen.com/outlets#faq",
      mainEntity: [
        {
          "@type": "Question",
          name: "Where are Barbequeen Restaurant outlets located?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Barbequeen has multiple restaurant outlets across Tamil Nadu, including Salem, Coimbatore, Erode, Hosur, and other cities. Visit our Outlets page to find the nearest branch, address, and contact details.",
          },
        },
        {
          "@type": "Question",
          name: "Which is the nearest Barbequeen restaurant?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Use our Outlets page to find the nearest Barbequeen restaurant based on your city. Each branch offers authentic biryani, BBQ, tandoori, dine-in, takeaway, and delivery services where available.",
          },
        },
        {
          "@type": "Question",
          name: "What are the opening hours of Barbequeen outlets?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Most Barbequeen outlets are open daily from 11:00 AM to 11:00 PM, making it convenient for lunch, dinner, takeaway, and family dining. Please check your preferred outlet for any location-specific timings.",
          },
        },
        {
          "@type": "Question",
          name: "Do all Barbequeen outlets serve the same menu?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Most outlets serve Barbequeen's signature BBQ, biryani, tandoori, shawarma, Chinese, and Indian dishes. Menu availability may vary slightly by location and seasonal specials.",
          },
        },
        {
          "@type": "Question",
          name: "Can I reserve a table at any Barbequeen outlet?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. You can reserve a table by contacting your preferred Barbequeen outlet or using the online reservation option available on our website.",
          },
        },
        {
          "@type": "Question",
          name: "Do all Barbequeen outlets offer takeaway and delivery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Most Barbequeen outlets provide takeaway and home delivery. Delivery coverage may vary depending on your location and the nearest restaurant.",
          },
        },
        {
          "@type": "Question",
          name: "Which Barbequeen outlet is best for family dining?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Every Barbequeen outlet is designed for family dining, offering spacious seating, a welcoming atmosphere, and a menu featuring BBQ, biryani, mandi, tandoori, and multi-cuisine favourites.",
          },
        },
        {
          "@type": "Question",
          name: "Which Barbequeen outlet is best for birthday celebrations?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Most Barbequeen outlets are suitable for birthdays, anniversaries, and family gatherings, with group seating and customized dining arrangements available upon request.",
          },
        },
        {
          "@type": "Question",
          name: "Do Barbequeen outlets have parking facilities?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Parking availability varies by outlet. Please contact your preferred Barbequeen branch to confirm parking facilities before your visit.",
          },
        },
        {
          "@type": "Question",
          name: "Which Barbequeen outlet serves the best biryani?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "All Barbequeen outlets follow standardized recipes and quality standards, serving authentic Chicken Dum Biryani, Mutton Biryani, and signature BBQ dishes prepared with fresh ingredients.",
          },
        },
        {
          "@type": "Question",
          name: "Can I contact a specific Barbequeen outlet directly?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Every Barbequeen outlet has its own contact details. Visit the Outlets page to find the phone number, address, and location information for your preferred branch.",
          },
        },
        {
          "@type": "Question",
          name: "How do I find the nearest Barbequeen restaurant on Google Maps?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Visit our Outlets page and select your preferred branch to access its address, contact details, and Google Maps location for easy navigation.",
          },
        },
      ],
    },
  ],
};

export const krishnagiriPageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      url: "https://barbequeen.com/",
      logo: "https://barbequeen.com/images/logo.png",
      foundingDate: "1999",
      sameAs: [
        "https://facebook.com/BarbequeenRestaurant/",
        "https://instagram.com/barbequeenrestaurant/",
      ],
    },
    {
      "@type": "Restaurant",
      "@id":
        "https://barbequeen.com/best-restaurant-in-krishnagiri#krishnagiri",
      name: "Barbequeen - Krishnagiri",
      image: "https://barbequeen.com/images/barbequeen-krishnagiri.jpg",
      url: "https://barbequeen.com/best-restaurant-in-krishnagiri",
      telephone: "+919360866880",
      priceRange: "₹₹",
      servesCuisine: [
        "Biryani",
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "Chennai Exit Point, Chennai-Bengaluru Highway, Near K.P.N Lakshmi Mahal",
        addressLocality: "Krishnagiri",
        addressRegion: "Tamil Nadu",
        postalCode: "635001",
        addressCountry: "IN",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: "12.5266",
        longitude: "78.2141",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "FAQPage",
      "@id": "https://barbequeen.com/best-restaurant-in-krishnagiri#faq",
      mainEntity: [
        {
          "@type": "Question",
          name: "What makes Barbequeen the best restaurant in Krishnagiri?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Since 1999, we've served freshly cooked, generously portioned food built on real charcoal grilling and slow-cooked biryani. Handy for highway travellers and local families alike, it's why diners rate us the best restaurant in Krishnagiri.",
          },
        },
        {
          "@type": "Question",
          name: "Which is the best biryani in Krishnagiri?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our biryani layers aged basmati with freshly marinated meat over a gentle dum. Fluffy, aromatic rice and tender meat make it a top pick for the best biryani in Krishnagiri.",
          },
        },
        {
          "@type": "Question",
          name: "Where can I get the best chicken biryani in Krishnagiri?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "At Barbequeen. We cook juicy, spice-marinated chicken into fragrant basmati until every layer is rich and flavourful, never dry, making it the best chicken biryani in Krishnagiri.",
          },
        },
        {
          "@type": "Question",
          name: "Where is the best mandi biryani in Krishnagiri?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our Arabian mandi tops fragrant spiced rice with meat so tender it falls off the bone, cooked low and slow. Smoky and aromatic, it's the best mandi biryani in Krishnagiri, available in chicken or mutton.",
          },
        },
        {
          "@type": "Question",
          name: "Where is Barbequeen located in Krishnagiri, and what are the timings?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You'll find us at the Chennai exit point on the Chennai to Bengaluru highway, near K.P.N Lakshmi Mahal. We're open daily, 11:00 AM to 11:00 PM, for dine-in, takeaway, and delivery.",
          },
        },
      ],
    },
  ],
};

export const coimbatorePageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      url: "https://barbequeen.com/",
      logo: "https://barbequeen.com/images/logo.png",
      foundingDate: "1999",
      sameAs: [
        "https://facebook.com/BarbequeenRestaurant/",
        "https://instagram.com/barbequeenrestaurant/",
      ],
    },
    {
      "@type": "Restaurant",
      "@id":
        "https://barbequeen.com/best-restaurant-in-coimbatore#saibaba-colony",
      name: "Barbequeen - Coimbatore (Saibaba Colony)",
      image: "https://barbequeen.com/images/barbequeen-coimbatore.jpg",
      url: "https://barbequeen.com/best-restaurant-in-coimbatore",
      telephone: "+919944744833",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress: "14, Alagesan Rd, Nesavaalar Colony, Saibaba Colony",
        addressLocality: "Coimbatore",
        addressRegion: "Tamil Nadu",
        postalCode: "641011",
        addressCountry: "IN",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: "11.0233",
        longitude: "76.9505",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "FAQPage",
      "@id": "https://barbequeen.com/best-restaurant-in-coimbatore#faq",
      mainEntity: [
        {
          "@type": "Question",
          name: "What makes Barbequeen the best restaurant in Coimbatore?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Since 1999, we've paired authentic charcoal grilling with fresh ingredients, dependable quality, and generous portions. From double-marinated grill chicken to biryani and mandi, it's why diners rate us the best restaurant in Coimbatore.",
          },
        },
        {
          "@type": "Question",
          name: "Where can I find the best barbecue in Coimbatore?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "At Barbequeen, home of the Double Marinated Grill Chicken, marinated twice and slow-cooked over live charcoal. Paired with our kababs and tandoori specials, it's the best barbecue in Coimbatore.",
          },
        },
        {
          "@type": "Question",
          name: "Which is the best biryani in Coimbatore?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We layer aged basmati with freshly marinated chicken or slow-cooked mutton over a gentle dum. Fluffy, aromatic rice and tender meat make it the best biryani in Coimbatore.",
          },
        },
        {
          "@type": "Question",
          name: "Where is Barbequeen located in Coimbatore, and what are the timings?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You'll find us on Alagesan Road in Saibaba Colony, Nesavaalar Colony. We're open daily, 11:00 AM to 11:00 PM, for dine-in, takeaway, and delivery.",
          },
        },
        {
          "@type": "Question",
          name: "Does Barbequeen Coimbatore offer delivery and vegetarian options?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we offer doorstep delivery plus online ordering via Swiggy and Zomato. Our menu also has a full veg spread, from paneer butter masala to starters and desserts.",
          },
        },
      ],
    },
  ],
};

export const erodePageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      url: "https://barbequeen.com/",
      logo: "https://barbequeen.com/images/logo.png",
      foundingDate: "1999",
      sameAs: [
        "https://facebook.com/BarbequeenRestaurant/",
        "https://instagram.com/barbequeenrestaurant/",
      ],
    },
    {
      "@type": "Restaurant",
      "@id": "https://barbequeen.com/best-restaurant-in-erode#erode",
      name: "Barbequeen - Erode",
      image: "https://barbequeen.com/images/barbequeen-erode.jpg",
      url: "https://barbequeen.com/best-restaurant-in-erode",
      telephone: "+919003760005",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress: "9, 10, Perundurai Rd, Opp. Sudha Hospital, V Chatram",
        addressLocality: "Erode",
        addressRegion: "Tamil Nadu",
        postalCode: "638011",
        addressCountry: "IN",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: "11.3410",
        longitude: "77.7172",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "FAQPage",
      "@id": "https://barbequeen.com/best-restaurant-in-erode#faq",
      mainEntity: [
        {
          "@type": "Question",
          name: "What makes Barbequeen the best restaurant in Erode?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Since 1999, we've combined genuine charcoal-grill craft with fresh ingredients, steady quality, and generous portions. From double-marinated grill chicken to biryani and mandi, it's why diners rate us the best restaurant in Erode.",
          },
        },
        {
          "@type": "Question",
          name: "Where can I find the best barbecue in Erode?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "At Barbequeen, home of the Double Marinated Grill Chicken, marinated twice and slow-charred over charcoal. Paired with our kababs and tandoori plates, it's the best barbecue in Erode.",
          },
        },
        {
          "@type": "Question",
          name: "Which is the best biryani in Erode?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We layer aged basmati with freshly marinated chicken or slow-cooked mutton over a gentle dum. Light, fragrant rice and tender meat make it the best biryani in Erode.",
          },
        },
        {
          "@type": "Question",
          name: "Where is Barbequeen located in Erode, and what are the timings?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You'll find us on Perundurai Road, opposite Sudha Hospital in V Chatram. We're open daily, 11:00 AM to 11:00 PM, for dine-in, takeaway, and delivery.",
          },
        },
        {
          "@type": "Question",
          name: "Does Barbequeen Erode offer delivery and vegetarian options?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we offer doorstep delivery plus online ordering via Swiggy and Zomato. Our menu also has a full veg spread, from paneer butter masala to starters and desserts.",
          },
        },
      ],
    },
  ],
};

export const salemPageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      url: "https://barbequeen.com/",
      logo: "https://barbequeen.com/images/logo.png",
      foundingDate: "1999",
      sameAs: [
        "https://facebook.com/BarbequeenRestaurant/",
        "https://instagram.com/barbequeenrestaurant/",
      ],
    },
    {
      "@type": "Restaurant",
      "@id": "https://barbequeen.com/best-restaurant-in-salem#five-roads",
      name: "Barbequeen - Five Roads (Junction)",
      image: "https://barbequeen.com/images/barbequeen.jpg",
      url: "https://barbequeen.com/best-restaurant-in-salem",
      telephone: "+919659184555",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress: "Reliance Mall, Junction Main Rd",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636004",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "Restaurant",
      "@id": "https://barbequeen.com/best-restaurant-in-salem#sona",
      name: "Barbequeen - Sona",
      image: "https://barbequeen.com/images/barbequeen.jpg",
      url: "https://barbequeen.com/best-restaurant-in-salem",
      telephone: "+919659174555",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress: "Junction Main Rd, Near Sona College, Subramania Nagar",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636005",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "Restaurant",
      "@id": "https://barbequeen.com/best-restaurant-in-salem#fairlands",
      name: "Barbequeen - Fairlands",
      image: "https://barbequeen.com/images/barbequeen.jpg",
      url: "https://barbequeen.com/best-restaurant-in-salem",
      telephone: "+919003610005",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress: "31, Greenways Rd, Sinthampalayam, Fairlands",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636016",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "Restaurant",
      "@id": "https://barbequeen.com/best-restaurant-in-salem#hasthampatty",
      name: "Barbequeen - Hasthampatty",
      image: "https://barbequeen.com/images/barbequeen.jpg",
      url: "https://barbequeen.com/best-restaurant-in-salem",
      telephone: "+919894055651",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress: "No 43, N.C.A.S. Building, Hasthampatti Main Rd",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636007",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "Restaurant",
      "@id": "https://barbequeen.com/best-restaurant-in-salem#gugai",
      name: "Barbequeen - Gugai",
      image: "https://barbequeen.com/images/barbequeen.jpg",
      url: "https://barbequeen.com/best-restaurant-in-salem",
      telephone: "+919003344900",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress: "No 402, Trichy Main Rd, Sendarapatti, Gugai",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636006",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "Restaurant",
      "@id": "https://barbequeen.com/best-restaurant-in-salem#cherry-road",
      name: "Barbequeen - Cherry Road",
      image: "https://barbequeen.com/images/barbequeen.jpg",
      url: "https://barbequeen.com/best-restaurant-in-salem",
      telephone: "+919659204555",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress: "223, Cherry Rd, Near Eswaran Temple, Opp. Petrol Pump",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636001",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "Restaurant",
      "@id":
        "https://barbequeen.com/best-restaurant-in-salem#seelanaickenpatti",
      name: "Barbequeen - Seelanaickenpatti",
      image: "https://barbequeen.com/images/barbequeen.jpg",
      url: "https://barbequeen.com/best-restaurant-in-salem",
      telephone: "+919003320433",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "Trichy Main Rd, Annamali Nagar, MGR Nagar, Seelanaickenpatti",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636201",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "Restaurant",
      "@id": "https://barbequeen.com/best-restaurant-in-salem#modern-theatre",
      name: "Barbequeen - Modern Theatre",
      image: "https://barbequeen.com/images/barbequeen.jpg",
      url: "https://barbequeen.com/best-restaurant-in-salem",
      telephone: "+919087222285",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "61, Yercaud Main Rd, Near Modern Theatre, Chinnakollapatty",
        addressLocality: "Salem",
        addressRegion: "Tamil Nadu",
        postalCode: "636008",
        addressCountry: "IN",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
    {
      "@type": "FAQPage",
      "@id": "https://barbequeen.com/best-restaurant-in-salem#faq",
      mainEntity: [
        {
          "@type": "Question",
          name: "What makes Barbequeen the best restaurant in Salem?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Since 1999, we've paired real charcoal-grill expertise with consistent quality and generous portions, from double-marinated grill chicken to biryani and mandi.",
          },
        },
        {
          "@type": "Question",
          name: "Where can I find the best barbecue in Salem?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "At Barbequeen, home of the Double Marinated Grill Chicken, marinated twice and charcoal-grilled till smoky and tender, alongside our kababs and tandoori specials.",
          },
        },
        {
          "@type": "Question",
          name: "Which is the best biryani in Salem?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We layer aged basmati with marinated chicken or slow-cooked mutton over a gentle dum. Fluffy rice, tender meat, and balanced spice.",
          },
        },
        {
          "@type": "Question",
          name: "How many outlets are there, and what are the timings?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We run eight outlets across Salem, from Five Roads to Modern Theatre. All are open daily, 11:00 AM to 11:00 PM, for dine-in, takeaway, and delivery.",
          },
        },
        {
          "@type": "Question",
          name: "Does Barbequeen offer delivery and vegetarian options?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Doorstep delivery plus online ordering via Swiggy and Zomato. Our menu also has a full veg spread, from paneer butter masala to starters and desserts.",
          },
        },
      ],
    },
  ],
};

export const pudukkottaiPageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      url: "https://barbequeen.com/",
      logo: "https://barbequeen.com/assets/images/logo.png",
      foundingDate: "1999",
      sameAs: [
        "https://facebook.com/BarbequeenRestaurant/",
        "https://instagram.com/barbequeenrestaurant/",
      ],
    },
    {
      "@type": "Article",
      headline: "Best Restaurant in Pudukkottai: Why Families Choose Barbequeen",
      description:
        "Discover why families consider Barbequeen the best restaurant in Pudukkottai. From wood-fire seeraga samba dum biryani and double-marinated grills to a family-friendly atmosphere, explore what makes our SIPCOT Industrial Park outlet special.",
      image: "https://barbequeen.com/assets/images/og-image.jpg",
      author: {
        "@type": "Organization",
        name: "Barbequeen Restaurant",
      },
      publisher: {
        "@type": "Organization",
        name: "Barbequeen",
        logo: {
          "@type": "ImageObject",
          url: "https://barbequeen.com/assets/images/logo.png",
        },
      },
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": "https://barbequeen.com/blog/best-restaurant-in-pudukkottai",
      },
      about: {
        "@type": "Restaurant",
        "@id": "https://barbequeen.com/blog/best-restaurant-in-pudukkottai#sipcot",
        name: "Barbequeen Restaurant - Pudukkottai",
        image: "https://barbequeen.com/images/barbequeen-pudukkottai-og.jpg",
        url: "https://barbequeen.com/blog/best-restaurant-in-pudukkottai",
        telephone: "+91 86757 95788",
        priceRange: "₹₹",
        servesCuisine: [
          "Barbecue",
          "Chettinad",
          "Biryani",
          "Tandoori",
          "Chinese",
          "Mandi",
        ],
        parentOrganization: { "@id": "https://barbequeen.com/#organization" },
        address: {
          "@type": "PostalAddress",
          streetAddress:
            "Plot No. 3 B/3, Door No. 1665, Nalan Food Products, SIPCOT Industrial Park",
          addressLocality: "Pudukkottai",
          addressRegion: "Tamil Nadu",
          postalCode: "622002",
          addressCountry: "IN",
        },
        geo: {
          "@type": "GeoCoordinates",
          latitude: "10.3833",
          longitude: "78.8001",
        },
        openingHoursSpecification: {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ],
          opens: "11:00",
          closes: "23:00",
        },
        menu: "https://barbequeen.com/menu",
        sameAs: [
          "https://facebook.com/BarbequeenRestaurant/",
          "https://instagram.com/barbequeenrestaurant/",
        ],
      },
    },
    {
      "@type": "FAQPage",
      "@id": "https://barbequeen.com/blog/best-restaurant-in-pudukkottai#faq",
      mainEntity: [
        {
          "@type": "Question",
          name: "Which is the best restaurant in Pudukkottai for family dinners and biryani?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "For wood-fire dum biryani, double marinated grill chicken and a relaxed family setting, Barbequeen Restaurant is a dependable choice. Our recipes have been served across Tamil Nadu since 1999.",
          },
        },
        {
          "@type": "Question",
          name: "Is Barbequeen the best family restaurant in Pudukkottai?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We'll let you be the judge. Our menu runs from mild to spicy, and bucket biryani makes sharing easy for big families.",
          },
        },
        {
          "@type": "Question",
          name: "What makes Barbequeen stand out as a biryani restaurant in Pudukkottai?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We still cook on wood fire, dum style, with seeraga samba rice. Every plate comes with khatta gravy and onion raitha.",
          },
        },
        {
          "@type": "Question",
          name: "What should I order on my first visit?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Share a chicken or mutton biryani and a grill chicken. If anyone at the table prefers milder food, add a mandi.",
          },
        },
        {
          "@type": "Question",
          name: "Is the menu in Pudukkottai the same as at other Barbequeen outlets?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our core dishes, including biryani, grill chicken and tandoori, follow the same recipes everywhere. A few items can vary by outlet, so ask our team what's on today.",
          },
        },
      ],
    },
  ],
};

export const pudukkottaiBiryaniPageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "BlogPosting",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": "https://barbequeen.com/blog/best-biryani-in-pudukkottai",
      },
      headline: "Best Biryani in Pudukkottai: Wood-Fire Dum Biryani at Barbequeen",
      description:
        "Discover the best biryani in Pudukkottai at Barbequeen. Learn about wood-fire dum biryani, seeraga samba rice, and what makes a great traditional biryani.",
      author: {
        "@type": "Organization",
        name: "Barbequeen",
      },
      publisher: {
        "@type": "Organization",
        name: "Barbequeen",
        logo: {
          "@type": "ImageObject",
          url: "https://barbequeen.com/logo.png",
        },
      },
      datePublished: "2026-03-30",
      dateModified: "2026-03-30",
      about: {
        "@type": "Restaurant",
        name: "Barbequeen Restaurant - SIPCOT Industrial Park",
        address: {
          "@type": "PostalAddress",
          streetAddress:
            "Plot No. 3 B/3, Door No. 1665, Nalan Food Products, SIPCOT Industrial Park",
          addressLocality: "Pudukkottai",
          addressRegion: "Tamil Nadu",
          postalCode: "622002",
          addressCountry: "IN",
        },
        telephone: "+91 86757 95788",
      },
    },
    {
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Where can I find the best biryani in Pudukkottai?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Look for seeraga samba rice, real dum cooking and meat seasoned to the bone. Barbequeen's wood-fire dum biryani is cooked to that standard and served with khatta and raitha.",
          },
        },
        {
          "@type": "Question",
          name: "What should the best chicken biryani in Pudukkottai taste like?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "The chicken should be juicy and well seasoned, and the grains should stay separate. The rice should taste of meat and spices, not oil.",
          },
        },
        {
          "@type": "Question",
          name: "Which rice does Barbequeen use for biryani?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Seeraga samba, a short-grain aromatic rice grown in Tamil Nadu. It absorbs masala better than long-grain rice, which is why it suits dum biryani.",
          },
        },
        {
          "@type": "Question",
          name: "Is there more on the menu than biryani?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. You can order double-marinated grill chicken, tandoori, mandi, shawarma and Chinese dishes, so mixed groups are easy to feed.",
          },
        },
        {
          "@type": "Question",
          name: "Can I order biryani for a party?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. The half-kilo chicken bucket biryani serves three to four people. For bigger gatherings, call the outlet in advance to plan quantities.",
          },
        },
      ],
    },
  ],
};

export const bestBbqRestaurantInPudukkottaiSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "BlogPosting",
      "@id": "https://barbequeen.com/blog/best-bbq-restaurant-pudukkottai#article",
      "headline":
        "Charcoal Smoke and Biryani Steam: The Best BBQ Restaurant in Pudukkottai",
      "description":
        "Discover what makes authentic charcoal grill and wood-fired biryani in Pudukkottai. Read our guide on double-marinated chicken, Arcot-style biryani, and family dining tips at Barbequeen.",
      "articleBody":
        "Good barbecue is easy to recognise once you know what to look for. Before you trust any review, check four key things: deep marination, proper char, juicy meat near the bone, and taste consistency. At Barbequeen Restaurant in Pudukkottai, we serve double-marinated chicken, wood-fired Arcot-style seeraga samba biryani, Mandi, and tandoori specials.",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://barbequeen.com/blog/best-bbq-restaurant-pudukkottai",
      },
      "inLanguage": "en-IN",
      "author": {
        "@type": "Organization",
        "name": "Barbequeen Restaurant",
        "url": "https://barbequeen.com",
      },
      "publisher": {
        "@id": "https://barbequeen.com/#restaurant",
      },
      "about": {
        "@id": "https://barbequeen.com/#restaurant",
      },
    },
    {
      "@type": "Restaurant",
      "@id": "https://barbequeen.com/#restaurant",
      "name": "Barbequeen Restaurant",
      "image": "https://barbequeen.com/assets/images/logo.png",
      "url": "https://barbequeen.com",
      "telephone": "+91-86757-95788",
      "priceRange": "₹₹",
      "servesCuisine": [
        "Barbecue",
        "Biryani",
        "Tandoori",
        "Arabian",
        "Indian",
        "Chinese",
      ],
      "address": {
        "@type": "PostalAddress",
        "streetAddress":
          "Plot No. 3 B/3, Door No. 1665, Nalan Food Products, SIPCOT Industrial Park",
        "addressLocality": "Pudukkottai",
        "addressRegion": "Tamil Nadu",
        "postalCode": "622002",
        "addressCountry": "IN",
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 10.3797,
        "longitude": 78.8208,
      },
      "hasMenu": "https://barbequeen.com/menu",
      "acceptsReservations": "True",
    },
  ],
};

export const bestBbqRestaurantInPudukkottaiFaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Which is the best BBQ restaurant in Pudukkottai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text":
          "We're biased, so judge us by the plate. Barbequeen has been grilling for Tamil Nadu diners since 1999, and our Pudukkottai outlet serves the same double-marinated grill chicken and wood-fired biryani.",
      },
    },
    {
      "@type": "Question",
      "name": "Is Barbequeen a biryani restaurant in Pudukkottai or a BBQ place?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text":
          "Both. Biryani and grills are our two specialities, so we always suggest ordering one of each.",
      },
    },
    {
      "@type": "Question",
      "name": "What makes the best mutton biryani in Pudukkottai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text":
          "Three things: mutton that comes apart under a spoon, rice that stays separate, and masala cooked into the meat rather than poured on top. Our one-pot dum biryani is built around all three.",
      },
    },
    {
      "@type": "Question",
      "name": "Do you have vegetarian options?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text":
          "Yes. Paneer dishes, veg meals, soups and Indian breads are on the menu, so vegetarians at the table aren't left out.",
      },
    },
    {
      "@type": "Question",
      "name": "What should I order on my first visit?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text":
          "Start with our double-marinated grill chicken and a chicken biryani. Add mutton biryani for bigger appetites and mandi for anyone who prefers milder food.",
      },
    },
  ],
};

